export default function initwerbung(){
    var getMaxHeightInSet = function (selector) {
        return Math.max.apply(null, $(selector).map(function () {
            return $(this).height();
        }).get());
    };
    var gridReset = function () {
        $(".mod-img-wth-list, .mod-img-wth-list .module-content").css("height", "");
    };
    var gridFix = function () {
        gridReset();

        $(".mod-img-wth-list").not(".col-md-4 .mod-img-wth-list").height(getMaxHeightInSet(".mod-img-wth-list"));
        $(".mod-img-wth-list .module-content").not(".col-md-4 .mod-img-wth-list .module-content").height(getMaxHeightInSet(".mod-img-wth-list .module-content"));
    };

    var gueltigToBottom = function () {
        $(".gueltig-sm").each(function () {
            if ($(this).height() + $(this).prev().height() < $(this).parent().parent().prev().children("img").height()) {
                var biggerMargin = $(this).parent().parent().prev().children("img").height() - $(this).prev().height() - $(this).height();
                $(this).css("marginTop", biggerMargin + "px");
            } else {
                $(this).css("marginTop", "0");
            }
        });
    };
    $(window).on("resize", function () {
        gueltigToBottom();
    });
    gueltigToBottom();
    //Fix für Grid mit unterschiedlichen Containerhöhen
    $(window).on("resize", function () {
        gridReset();
        gridFix();
    });
    gridReset();
    gridFix();
}